import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { breakpoint: { type: Number, default: 1024 } }

  navigate(event) {
    if (window.innerWidth >= this.breakpointValue) {
      const url = event.currentTarget.href
      event.preventDefault()
      fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html, text/html, application/xhtml+xml",
        },
      })
        .then((response) => response.text())
        .then((html) => Turbo.renderStreamMessage(html))
        .catch(() => {
          window.location.href = url
        })
    }
    // Mobile: let default Turbo Drive navigation happen (full page)
  }
}
